import { Outlet, useParams } from 'react-router-dom'

import { TrainingFormsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { FormsOverview } from 'modules/trainings/components/Revamp/TrainingsDetail/Forms'
import { EmptyStateForms } from 'modules/trainings/components/Revamp/TrainingsDetail/Forms/EmptyState'

const Overview = ({ formsCount, id }: { formsCount?: number; id: string }) => {
  if (formsCount && formsCount > 0) {
    return <FormsOverview trainingId={String(id)} />
  } else {
    return <EmptyStateForms trainingId={String(id)} />
  }
}

const Forms = () => {
  const { id } = useParams<'id'>()

  const { data, loading } = useQuery(TrainingFormsDocument, {
    variables: { resourceId: id ?? '' },
  })
  const formsCount = data?.forms.formsConnection.totalCount ?? undefined
  if (loading) return <></>
  return (
    <ResponsivePage.Body showHeader={false}>
      <Overview formsCount={formsCount} id={String(id)} />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default Forms
